import { CategoryParamUnit } from "@/Models/Category";


export const getUnitText = (unit: CategoryParamUnit | string) => {
  switch (unit) {
    case 'KM': {
      return 'km'
    }
    case 'M2': {
      return 'м²'
    }
    case 'M3': {
      return 'м³'
    }
    default: {
      return '';
    }
  }
}
